import { atom } from "recoil"

/**
 * 組織選択ドロップダウンの開閉状態を管理するアトム
 */
export const isOrganizationSelectorOpenState = atom({
  key: "isOrganizationSelectorOpenState",
  default: false,
})
